import {createAction} from '@reduxjs/toolkit'

import {AlarmType, CashReceiptIssueUsageType, CertificationMethodType} from '@web/core/constants'

/** alert type 변경 */
export const setAlarmType = createAction<Maybe<AlarmType>>('purchaser/setAlarmType')

/** 성인 인증 정보 반영 */
export const setAdultToken = createAction<{
    /** 성인 인증 토큰 정보 */
    token: string
    /** 성인 인증 방법 */
    certificationMethod: Maybe<CertificationMethodType>
}>('purchaser/setAdultToken')

/** 성인 인증 정보 클리어 */
export const clearAdultToken = createAction('purchaser/clearAdultToken')

/** 현금 영수증 > 저장여부 */
export const toggleCashReceiptIsUpdate = createAction<boolean>('purchaser/toggleCashReceiptIsUpdate')

/** 현금 영수증 > 개인소득공재용 | 사업자증빙용 */
export const selectCashReceiptType = createAction<CashReceiptIssueUsageType>('purchaser/selectCashReceiptType')
